import { StatusBadge } from '@/components/Common/StatusBadge/StatusBadge';
import COLORS from '@/constants/colors';
import { ChevronRight } from '@mui/icons-material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box } from '@mui/material';
import { OrderDetailItemUi } from './OrdersDetailUi';

export const rowStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const itemGenerator = (item: OrderDetailItemUi) => {
  return [
    <>
      <Box
        width="8ch"
        sx={{
          ...rowStyle,
        }}
      >
        {item.orderNumber}
      </Box>
    </>,
    <>
      <Box
        minWidth="15ch"
        maxWidth="20ch"
        sx={{
          ...rowStyle,
        }}
      >
        {item.sellerName}
      </Box>
    </>,
    <>
      <Box
        minWidth="15ch"
        maxWidth="20ch"
        sx={{
          ...rowStyle,
        }}
      >
        {item.buyerName}
      </Box>
    </>,
    <>
      <Box
        width="10ch"
        sx={{
          ...rowStyle,
        }}
      >
        {item.kamOwner}
      </Box>
    </>,
    <>
      <Box
        width="17ch"
        sx={{
          ...rowStyle,
        }}
      >
        {item.orderDate}
      </Box>
    </>,
    <>
      <Box>{item.badgeStatus && <StatusBadge badge={item.badgeStatus} />}</Box>
    </>,
    <>
      <Box display={'flex'} alignContent={'center'} justifyContent={'center'}>
        {item.remission && (
          <CheckCircleOutlineIcon sx={{ color: COLORS.success_500 }} />
        )}
      </Box>
    </>,
    <>
      <Box
        width="9ch"
        sx={{
          ...rowStyle,
        }}
      >
        ${item.total}
      </Box>
    </>,
    <>
      <ChevronRight sx={{ padding: '0px' }} />
    </>,
  ];
};
